/** Shared products list page size (POS `start`/`size`). Keep free of store imports. */
export const PRODUCTS_PAGE_SIZE = 200;
